export default __webpack_public_path__ + "static/media/drilling.5b4d512a.jpg";